import { apiClient } from "../../../../lib/axios";

export type WellbeingFact = {
  id: string;
  title: string;
  body: string;
  category?: string | null;
  source?: string | null;
  isActive?: boolean | null;
  startsOn?: string | null;
  endsOn?: string | null;
  priority?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type WellbeingCarouselItem = {
  id: string;
  title: string;
  body?: string | null;
  imageUrl?: string | null;
  mediaUrl?: string | null;
  mediaType?: string | null;
  tag?: string | null;
  actionLabel?: string | null;
  actionUrl?: string | null;
  isActive?: boolean | null;
  startsOn?: string | null;
  endsOn?: string | null;
  priority?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type WellbeingUploadResponse = {
  upload_url: string;
  file_url: string;
  key: string;
};

export const wellbeingContentApi = {
  listFacts: async (params?: {
    category?: string;
    is_active?: boolean;
  }): Promise<WellbeingFact[]> => {
    const response = await apiClient.get("/admin/wellbeing/facts", {
      params,
    });
    return response.data;
  },

  createFact: async (payload: {
    title: string;
    body: string;
    category?: string | null;
    source?: string | null;
    is_active?: boolean;
    starts_on?: string | null;
    ends_on?: string | null;
    priority?: number;
  }): Promise<WellbeingFact> => {
    const response = await apiClient.post("/admin/wellbeing/facts", payload);
    return response.data;
  },

  updateFact: async (
    id: string,
    payload: {
      title?: string;
      body?: string;
      category?: string | null;
      source?: string | null;
      is_active?: boolean;
      starts_on?: string | null;
      ends_on?: string | null;
      priority?: number;
    },
  ): Promise<WellbeingFact> => {
    const response = await apiClient.patch(
      `/admin/wellbeing/facts/${id}`,
      payload,
    );
    return response.data;
  },

  deactivateFact: async (id: string): Promise<WellbeingFact> => {
    const response = await apiClient.patch(
      `/admin/wellbeing/facts/${id}/deactivate`,
    );
    return response.data;
  },

  listCarousel: async (params?: { is_active?: boolean }): Promise<WellbeingCarouselItem[]> => {
    const response = await apiClient.get("/admin/wellbeing/carousel", {
      params,
    });
    return response.data;
  },

  createCarousel: async (payload: {
    title: string;
    body?: string | null;
    image_url?: string | null;
    media_url?: string | null;
    media_type?: string | null;
    tag?: string | null;
    action_label?: string | null;
    action_url?: string | null;
    is_active?: boolean;
    starts_on?: string | null;
    ends_on?: string | null;
    priority?: number;
  }): Promise<WellbeingCarouselItem> => {
    const response = await apiClient.post("/admin/wellbeing/carousel", payload);
    return response.data;
  },

  updateCarousel: async (
    id: string,
    payload: {
      title?: string;
      body?: string | null;
      image_url?: string | null;
      media_url?: string | null;
      media_type?: string | null;
      tag?: string | null;
      action_label?: string | null;
      action_url?: string | null;
      is_active?: boolean;
      starts_on?: string | null;
      ends_on?: string | null;
      priority?: number;
    },
  ): Promise<WellbeingCarouselItem> => {
    const response = await apiClient.patch(
      `/admin/wellbeing/carousel/${id}`,
      payload,
    );
    return response.data;
  },

  createCarouselUploadUrl: async (payload: {
    filename: string;
    content_type: string;
  }): Promise<WellbeingUploadResponse> => {
    const response = await apiClient.post(
      "/admin/wellbeing/carousel/upload-url",
      payload,
    );
    return response.data;
  },
};
